import Shop from '../components/shop/Shop';
import CategoryFilter from '../components/common/CategoryFilter.jsx';
const HomePage = () => {
    return (
        <>
        {/* <CategoryFilter /> */}
        <Shop/>
        </>
    );
};

export default HomePage;
